import React from 'react';
import { BIRIMLER, birimAdi } from './ayarlar';

// Sayı input'undaki tarayıcı artır/azalt oklarını gizler (daha temiz görünüm).
const noSpinner =
  '[appearance:textfield] [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none';

/**
 * Kanun yolu süresi girişi — yuvarlak uçlu beyaz gövde içinde, içeride yüzen
 * tamamen yuvarlatılmış lacivert birim "çipi" (uygulamanın lacivert+altın dili).
 * Spinner okları yok. sure dış dünyada string (yazarken boş bırakılabilsin).
 */
function SureSecimi({ sure, birim, onSureChange, onSureBlur = () => {}, onBirimChange }) {
  return (
    <div className="flex items-stretch rounded-full border border-slate-300 bg-white p-1 shadow-sm transition-all duration-200 focus-within:border-amber-500 focus-within:ring-2 focus-within:ring-amber-500/25">
      {/* Sol — sayı */}
      <input
        type="number"
        min="1"
        max="999"
        inputMode="numeric"
        className={`min-w-0 flex-1 bg-transparent px-4 text-center text-lg font-semibold tabular-nums text-slate-800 outline-none placeholder:text-slate-300 ${noSpinner}`}
        value={sure}
        onChange={(e) => onSureChange(e.target.value)}
        onBlur={onSureBlur}
        aria-label="Süre"
      />

      {/* Sağ — birim çipi (içeride yüzen, tamamen yuvarlak) */}
      <div className="relative ml-1 flex-none">
        <select
          className="h-full cursor-pointer appearance-none rounded-full bg-gradient-to-b from-slate-700 to-slate-900 py-2.5 pl-4 pr-9 text-sm font-semibold text-amber-300 outline-none transition-all hover:from-slate-600 hover:to-slate-800"
          aria-label="Süre birimi"
          value={birim}
          onChange={(e) => onBirimChange(e.target.value)}
        >
          {BIRIMLER.map((b) => (
            <option key={b} value={b} className="bg-white text-slate-800">{birimAdi(b)}</option>
          ))}
        </select>
        <svg
          className="pointer-events-none absolute right-3.5 top-1/2 h-3 w-3 -translate-y-1/2 text-amber-300/80"
          viewBox="0 0 12 12"
          fill="none"
        >
          <path d="M2 4l4 4 4-4" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </div>
    </div>
  );
}

export default SureSecimi;
